/**
 * Clean option name by removing identifier suffix (e.g., "| EK244M")
 * @param {string} optionName - Original option name (e.g., "Piston Ring Set | EK244")
 * @returns {string} Cleaned option name (e.g., "Piston Ring Set")
 */
function cleanOptionName(optionName) {
    if (!optionName) return optionName;
    return optionName.split('|')[0].trim();
}

/**
 * Convert string to handleized format for property names
 * @param {string} name - Name to handleize
 * @returns {string} Handleized name (e.g., "piston-ring-set")
 */
function handleize(name) {
    return name
        .toLowerCase()                   // Convert to lowercase
        .replace(/\s+/g, '-')           // Replace spaces with hyphens
        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars except hyphens
        .replace(/\-\-+/g, '-')         // Replace multiple hyphens with single
        .replace(/^-+/, '')             // Trim hyphens from start
        .replace(/-+$/, '');            // Trim hyphens from end
}

// Debug function to inspect search bundle data structure
window.debugSearchBundleData = function() {
    console.log('=== Search Bundle Data Debug Info ===');
    console.log('Available search bundle data:', window.searchBundleData);
    
    if (window.searchBundleData) {
        Object.keys(window.searchBundleData).forEach(productId => {
            const data = window.searchBundleData[productId];
            console.log(`Search Product ${productId}:`, {
                bundle_name: data.bundle_name,
                bundle_metaobject_id: data.bundle_metaobject_id,
                main_product_id: data.product,
                main_product_title: data.main_product_title,
                options_count: data.bundle_options?.[0]?.options?.length || 0
            });
        });
    }
    console.log('=== End Search Debug Info ===');
};

window.searchBundleManager = {
    initialized: new Set(),
    bundleCache: new Map(),

    async initializeSearchResults(container, context = 'search') {
        // console.log('Search bundle manager: Looking for product cards in container:', container);
        const bundleCards = container.querySelectorAll('product-card[attr-prod-id]');
        // console.log('Search bundle manager: Found product cards:', bundleCards.length);

        for (const card of bundleCards) {
            const productId = card.getAttribute("attr-prod-id");
            const bundleChooseBtn = card.querySelector("#bundle-choose");
            
            // console.log(`Search bundle manager: Processing card for product ${productId}, has bundle-choose button:`, !!bundleChooseBtn);
            // console.log(`Search bundle manager: Has bundle data for product ${productId}:`, !!window.searchBundleData?.[productId]);

            if (bundleChooseBtn && !this.initialized.has(productId)) {
                // console.log(`Search bundle manager: Initializing bundle for product ${productId}`);
                await this.initializeBundleProduct(card, productId, context);
                this.initialized.add(productId);
            } else if (!bundleChooseBtn) {
                // console.log(`Search bundle manager: No bundle-choose button found for product ${productId}`);
            } else if (this.initialized.has(productId)) {
                // console.log(`Search bundle manager: Product ${productId} already initialized`);
            }
        }
    },

    async initializeBundleProduct(productCardElement, productId, context) {
        const bundleData = window.searchBundleData?.[productId];

        if (bundleData) {
            console.log(`Search bundle data found via metafield for product ${productId}:`, {
                bundle_name: bundleData.bundle_name,
                bundle_metaobject_id: bundleData.bundle_metaobject_id,
                main_product_title: bundleData.main_product_title,
                options_count: bundleData.bundle_options?.[0]?.options?.length || 0
            });
            this.bundleCache.set(productId, bundleData);
            this.injectBundleOptions(productCardElement, bundleData, productId);
        } else {
            // console.warn(`No bundle data found for product ${productId} in ${context} context.`);
            // console.log('Available search bundle data keys:', Object.keys(window.searchBundleData || {}));
            const addToCartButton = productCardElement.querySelector(".buddle-atc-btn");
            if (addToCartButton) addToCartButton.removeAttribute("disabled");
            const bundleChooseButton = productCardElement.querySelector("#bundle-choose");
            if (bundleChooseButton) bundleChooseButton.removeAttribute("disabled");
        }
    },

    injectBundleOptions(productCardElement, bundleData, parentProductId) {
        let option_set = '<div class="bold_option_set hide-bundle-choose">';
        let optionsHtml = '';
        let name_attributes = [];
        let product_attributes = [];
        let varient_attributes = [];
        let price_attributes = [];
        let qty_attributes = [];
        let shop_product_id = parseInt(parentProductId);

        if (bundleData.bundle_options && bundleData.bundle_options[0] && bundleData.bundle_options[0].options) {
            const options_data = bundleData.bundle_options[0].options;
            
            options_data.forEach((option, b) => {
                const required_type = (option.is_required == 1) ? "required" : "";

                if (option.options_values && option.options_values.length > 1) {
                    const cleanedOptionName = cleanOptionName(option.bundle_option_name);
                    const handleizeName = handleize(cleanedOptionName);
                    optionsHtml += `<div class="bold_option bold_option_dropdown 15 ${handleizeName}"><label>`;
                    optionsHtml += `<span class="bold_option_title">${cleanedOptionName}</span>`;
                    optionsHtml += `<span class="bold_option_element"><select id="dd_select_${parentProductId}_${b}" attr-name="${cleanedOptionName}" name="properties[${cleanedOptionName}]" data-original-name="${option.bundle_option_name}" data-bundle-option-id="${option.bundle_option_id || ''}" class="bundle_option_select" ${required_type}>`;
                    optionsHtml += `<option value="">-- Choose ${cleanOptionName(option.bundle_option_name)} --</option>`;

                    option.options_values.forEach((variant, v) => {
                        if (variant.available !== false) {
                            const selected = (variant.is_default == 1) ? 'selected' : '';
                            const variantQty = (variant.qty != null && variant.qty !== '') ? String(variant.qty) : '1';
                            optionsHtml += `<option value="${variant.option_value}" data-option_value_key="${v}" data-variant-id="${variant.varient_id}" data-product-id="${variant.product_id}" data-price="${variant.price}" data-qty="${variantQty}" data-original-value="${variant.option_value}" ${selected}>${cleanOptionName(variant.option_value)}</option>`;
                        }
                    });
                    optionsHtml += `</select></span></label></div>`;
                } else if (option.options_values && option.options_values.length === 1) {
                    const variant = option.options_values[0];
                    if (variant.available !== false) {
                        const cleanedOptionName = cleanOptionName(option.bundle_option_name);
                        const handleizeName = handleize(cleanedOptionName);
                        const required_type = (option.is_required == 1) ? "required" : "";
                        
                        // Define which single-variant options should be visible
                        const visibleSingleVariantOptions = [
                            'Piston Set', 'Piston Ring Set', 'Main Bearing Set', 'Rod Bearing Set'
                        ];
                        
                        const shouldBeVisible = visibleSingleVariantOptions.some(visibleOption => 
                            cleanedOptionName.toLowerCase().includes(visibleOption.toLowerCase())
                        );
                        
                        const variantQty = (variant.qty != null && variant.qty !== '') ? String(variant.qty) : '1';
                        if (shouldBeVisible) {
                            // Create visible dropdown for important single-variant options
                            optionsHtml += `<div class="bold_option bold_option_dropdown 15 ${handleizeName}"><label>`;
                            optionsHtml += `<span class="bold_option_title">${cleanedOptionName}</span>`;
                            optionsHtml += `<span class="bold_option_element"><select id="dd_select_${parentProductId}_${b}" attr-name="${cleanedOptionName}" name="properties[${cleanedOptionName}]" data-original-name="${option.bundle_option_name}" data-bundle-option-id="${option.bundle_option_id || ''}" class="bundle_option_select" ${required_type}>`;
                            optionsHtml += `<option value="">-- Choose ${cleanOptionName(option.bundle_option_name)} --</option>`;
                            optionsHtml += `<option value="${variant.option_value}" data-option_value_key="0" data-variant-id="${variant.varient_id}" data-product-id="${variant.product_id}" data-price="${variant.price}" data-qty="${variantQty}" data-original-value="${variant.option_value}" selected>${cleanOptionName(variant.option_value)}</option>`;
                            optionsHtml += `</select></span></label></div>`;
                        } else {
                            // Create hidden dropdown for other single-variant options (like reference side)
                            optionsHtml += `<div class="bold_option bold_option_dropdown 17" style="display: none;"><label>`;
                            optionsHtml += `<span class="bold_option_title">${cleanedOptionName}</span>`;
                            optionsHtml += `<span class="bold_option_element"><select id="dd_select_${parentProductId}_${b}" style="display: none;" name="properties[${cleanedOptionName}]" data-original-name="${option.bundle_option_name}" data-bundle-option-id="${option.bundle_option_id || ''}" class="bundle_option_select" ${required_type}>`;
                            optionsHtml += `<option value="">-- Choose ${cleanOptionName(option.bundle_option_name)} --</option>`;
                            optionsHtml += `<option value="${variant.option_value}" data-option_value_key="0" data-variant-id="${variant.varient_id}" data-product-id="${variant.product_id}" data-price="${variant.price}" data-qty="${variantQty}" data-original-value="${variant.option_value}" selected>${cleanOptionName(variant.option_value)}</option>`;
                            optionsHtml += `</select></span></label></div>`;
                            
                            // Add to initial attributes for hidden single-variant options
                            name_attributes.push(variant.option_value);
                            product_attributes.push(variant.product_id);
                            varient_attributes.push(variant.varient_id);
                            qty_attributes.push(variant.qty || '1');
                            shop_product_id += parseInt(variant.varient_id);
                            price_attributes.push(variant.price.toString().replace(".", ""));
                        }
                    }
                }
            });
        }

        const nameAttributesStr = name_attributes.length > 0 ? name_attributes.join(",").trim() : "";
        const productAttributesStr = product_attributes.length > 0 ? product_attributes.join(",").trim() : "";
        const varientAttributesStr = varient_attributes.length > 0 ? varient_attributes.join(",").trim() : "";
        const qtyAttributesStr = qty_attributes.length > 0 ? qty_attributes.join(",").trim() : "";
        const priceAttributesStr = price_attributes.length > 0 ? price_attributes.join(",").trim().replace(".", "") : "";

        option_set += optionsHtml;
        option_set += `<div class="bold_option_total">
            <input type="hidden" name="properties[_boldVariantNames]" data-property-name="_boldVariantNames" value="${nameAttributesStr}">
            <input type="hidden" name="properties[_boldVariantIds]" data-property-name="_boldVariantIds" value="${varientAttributesStr}">
            <input type="hidden" name="properties[_boldProductIds]" data-property-name="_boldProductIds" value="${productAttributesStr}">
            <input type="hidden" name="properties[_boldVariantPrices]" data-property-name="_boldVariantPrices" value="0">
            <input type="hidden" name="properties[_boldVariantQtys]" data-property-name="_boldVariantQtys" value="${qtyAttributesStr}">
            <input type="hidden" name="properties[_boldBuilderId]" data-property-name="_boldBuilderId" value="${shop_product_id}">
        </div></div>`;

        const productForm = productCardElement.querySelector(".js-product-form");
        if (productForm) {
            productForm.insertAdjacentHTML("afterbegin", option_set);

            const addToCartButton = productCardElement.querySelector(".buddle-atc-btn");
            if (addToCartButton) addToCartButton.removeAttribute("disabled");
            const bundleChooseButton = productCardElement.querySelector("#bundle-choose");
            if (bundleChooseButton) bundleChooseButton.removeAttribute("disabled");
        }
    },

    updateBundleHiddenFieldsModal(productForm) {
        if (!productForm) return;

        const productCard = productForm.closest('product-card');
        if (!productCard) return;

        const parentBundleId = productCard.getAttribute("attr-prod-id");
        const bundleData = this.bundleCache.get(parentBundleId);

        if (!bundleData || !bundleData.bundle_options || !bundleData.bundle_options[0]) return;

        const optionsData = bundleData.bundle_options[0].options;
        let nameAttributes = [];
        let productAttributes = [];
        let varientAttributes = [];
        let qtyAttributes = [];
        let priceAttributes = [];
        let shopProductId = parseInt(parentBundleId);

        productForm.querySelectorAll(".bold_option_element select").forEach((selectElement, index) => {
            const selectedOption = selectElement.options[selectElement.selectedIndex];

            if (selectedOption && selectedOption.value) {
                const variantId = selectedOption.getAttribute('data-variant-id');
                const productId = selectedOption.getAttribute('data-product-id');
                const price = selectedOption.getAttribute('data-price');

                if (variantId && productId) {
                    const qty = selectedOption.getAttribute('data-qty') || '1';
                    nameAttributes.push(selectedOption.value);
                    productAttributes.push(productId);
                    varientAttributes.push(variantId);
                    qtyAttributes.push(qty);
                    shopProductId += parseInt(variantId);
                    priceAttributes.push(price ? price.toString().replace(".", "") : "0");
                }
            }
        });

        productForm.querySelectorAll('input[type="hidden"][data-variant-id]').forEach((hiddenInput) => {
            const variantId = hiddenInput.getAttribute('data-variant-id');
            const productId = hiddenInput.getAttribute('data-product-id');
            const price = hiddenInput.getAttribute('data-price');
            const qty = hiddenInput.getAttribute('data-qty') || '1';

            if (variantId && productId) {
                nameAttributes.push(hiddenInput.value);
                productAttributes.push(productId);
                varientAttributes.push(variantId);
                qtyAttributes.push(qty);
                shopProductId += parseInt(variantId);
                priceAttributes.push(price ? price.toString().replace(".", "") : "0");
            }
        });

        const nameAttributesStr = nameAttributes.length > 0 ? nameAttributes.join(",").trim() : "";
        const productAttributesStr = productAttributes.length > 0 ? productAttributes.join(",").trim() : "";
        const varientAttributesStr = varientAttributes.length > 0 ? varientAttributes.join(",").trim() : "";
        const qtyAttributesStr = qtyAttributes.length > 0 ? qtyAttributes.join(",").trim() : "";
        const priceAttributesStr = priceAttributes.length > 0 ? priceAttributes.join(",").trim().replace(".", "") : "";

        const boldOptionTotal = productForm.querySelector(".bold_option_total");
        if (boldOptionTotal) {
            const totalHtml = `
                <input type="hidden" name="properties[_boldVariantNames]" data-property-name="_boldVariantNames" value="${nameAttributesStr}">
                <input type="hidden" name="properties[_boldVariantIds]" data-property-name="_boldVariantIds" value="${varientAttributesStr}">
                <input type="hidden" name="properties[_boldProductIds]" data-property-name="_boldProductIds" value="${productAttributesStr}">
                <input type="hidden" name="properties[_boldVariantPrices]" data-property-name="_boldVariantPrices" value="0">
                <input type="hidden" name="properties[_boldVariantQtys]" data-property-name="_boldVariantQtys" value="${qtyAttributesStr}">
                <input type="hidden" name="properties[_boldBuilderId]" data-property-name="_boldBuilderId" value="${shopProductId}">
            `;
            boldOptionTotal.innerHTML = totalHtml;
        }
    },

    validateAndClearErrors(productForm) {
        if (!productForm) return;

        const bundleOptions = productForm.querySelector('.bold_option_set');
        if (!bundleOptions) return;

        const selects = bundleOptions.querySelectorAll('select.bundle_option_select');
        if (selects.length === 0) return;

        // Check if all required visible options are selected (ignore hidden single-variant dropdowns)
        const visibleSelects = Array.from(selects).filter(select => {
            const parentDiv = select.closest('.bold_option');
            return parentDiv && parentDiv.style.display !== 'none';
        });
        
        // For visible single-variant options that should be required, check if they're selected
        const allSelected = visibleSelects.every(select => {
            // If it's a visible single-variant option with only one choice, it should be auto-selected
            const allOptions = Array.from(select.querySelectorAll('option'));
            const nonEmptyOptions = allOptions.filter(option => option.value.trim() !== '');
            
            if (nonEmptyOptions.length === 1) {
                // Auto-select the single option if not already selected
                if (select.value.trim() === '') {
                    select.value = nonEmptyOptions[0].value;
                }
                return true; // Single option is considered valid
            }
            return select.value.trim() !== '';
        });

        if (allSelected) {
            // All options selected - clear any existing error messages
            const existingErrors = bundleOptions.querySelectorAll('.js-form-error, .required-error');
            existingErrors.forEach(error => error.remove());
            
            // Hide the required-message div if it exists
            const requiredMessage = productForm.querySelector('.required-message');
            if (requiredMessage) {
                requiredMessage.style.display = 'none';
            }
            
            // Remove red border styling from all visible selects
            visibleSelects.forEach(select => select.classList.remove('required-border'));
            
            console.log('Search bundle: All visible options selected, errors cleared');
        } else {
            // Not all visible options selected - add red border to empty visible selects
            visibleSelects.forEach(select => {
                if (select.value.trim() === '') {
                    select.classList.add('required-border');
                } else {
                    select.classList.remove('required-border');
                }
            });
        }
    }
};

document.addEventListener("click", function (event) {
    if (event.target.matches("#bundle-choose")) {
        event.preventDefault();
        event.stopPropagation();
        
        const productCard = event.target.closest("product-card");
        if (!productCard) return;
        
        const form = productCard.querySelector(".js-product-form");
        if (!form) return;
        
        const productId = productCard.getAttribute("attr-prod-id");
        
        // Hide the choose button
        event.target.classList.add("hide-bundle-choose");
        
        // Handle buyer's guide visibility
        const gridBuyerGuide = productCard.querySelector(".buyer-guide-wrap.buyer-guide-search-grid-layout");
        const listBuyerGuide = productCard.querySelector(".buyer-guide-wrap.buyer-guide-search-list-choose");

        if (gridBuyerGuide) {
            gridBuyerGuide.classList.add("hide-bundle-choose");
        }

        if (listBuyerGuide) {
            listBuyerGuide.classList.remove("hide-bundle-choose");
        }
        
        // Check if bundle options exist
        let bundleOptions = form.querySelector(".bold_option_set");
        
        if (bundleOptions) {
            // Bundle options already exist, just show them
            bundleOptions.classList.remove("hide-bundle-choose");
        } else {
            // No bundle options found - check if we have metaobject data
            const bundleData = window.searchBundleData?.[productId];
            
            if (bundleData) {
                // We have bundle data but options weren't injected yet - inject them now
                window.searchBundleManager.injectBundleOptions(productCard, bundleData, productId);
                bundleOptions = form.querySelector(".bold_option_set");
                if (bundleOptions) {
                    bundleOptions.classList.remove("hide-bundle-choose");
                }
            } else {
                // No bundle data available - this shouldn't happen now since we check at template level
                // console.warn(`No metaobject bundle data found for product ${productId}. Choose button should not be shown.`);
                
                // Show add to cart button directly
                const addToCartBtn = form.querySelector(".buddle-atc-btn");
                if (addToCartBtn) {
                    addToCartBtn.classList.remove("hide-bundle-choose");
                }
            }
        }
        
        // Show add to cart button
        const addToCartBtn = form.querySelector(".buddle-atc-btn");
        if (addToCartBtn) {
            addToCartBtn.classList.remove("hide-bundle-choose");
        }
        
        // Update bundle hidden fields with current selections (if bundle options exist)
        setTimeout(() => {
            if (form.querySelector(".bold_option_element select")) {
                window.searchBundleManager.updateBundleHiddenFieldsModal(form);
            }
        }, 100);
    }
});

document.addEventListener("change", (event) => {
    if (event.target.matches(".bundle_option_select")) {
        const productForm = event.target.closest("form");
        if (productForm) {
            const attrElement = event.target;
            const attrName = attrElement.getAttribute("attr-name");
            
            // Special handling for Piston Set -> Piston Ring Set (auto-suggestion)
            if (attrName === "Piston Set") {
                let pistonSet = attrElement.value;
                
                if (pistonSet && pistonSet !== "") {
                    const pistonRingSetElement = productForm.querySelector('.bold_option_element select[attr-name="Piston Ring Set"]');
                    if (pistonRingSetElement) {
                        // Convert "Piston Set" option to corresponding "Piston Ring Set" option
                        let pistonRingSet = pistonSet.replace("Piston Set", "Piston Ring Set");
                        
                        // Check if the corresponding option exists in Piston Ring Set dropdown
                        const optionExists = Array.from(pistonRingSetElement.options).some(opt => opt.value === pistonRingSet);
                        if (optionExists) {
                            // Only update if it's different from current selection
                            if (pistonRingSetElement.value !== pistonRingSet) {
                                pistonRingSetElement.value = pistonRingSet;
                                
                                // Add a visual indicator that this was auto-selected
                                pistonRingSetElement.style.backgroundColor = '#f0f8ff';
                                setTimeout(() => {
                                    pistonRingSetElement.style.backgroundColor = '';
                                }, 2000);
                                
                                // Trigger change event to update hidden fields
                                pistonRingSetElement.dispatchEvent(new Event('change', { bubbles: true }));
                                
                                // console.log(`Search: Auto-selected "${pistonRingSet}" based on "${pistonSet}" selection`);
                            }
                        } else {
                            console.log(`Search: No matching Piston Ring Set option found for "${pistonSet}"`);
                            // Reset Piston Ring Set to empty if no matching option exists
                            if (pistonRingSetElement.value !== "") {
                                pistonRingSetElement.value = "";
                                pistonRingSetElement.dispatchEvent(new Event('change', { bubbles: true }));
                            }
                        }
                    }
                } else {
                    // If Piston Set is cleared, also clear Piston Ring Set
                    const pistonRingSetElement = productForm.querySelector('.bold_option_element select[attr-name="Piston Ring Set"]');
                    if (pistonRingSetElement && pistonRingSetElement.value !== "") {
                        pistonRingSetElement.value = "";
                        pistonRingSetElement.dispatchEvent(new Event('change', { bubbles: true }));
                        console.log('Search: Cleared Piston Ring Set because Piston Set was cleared');
                    }
                }
            }
            
            window.searchBundleManager.updateBundleHiddenFieldsModal(productForm);
            
            // Clear error messages when user makes selections on search pages
            window.searchBundleManager.validateAndClearErrors(productForm);
        }
    }
});

document.addEventListener('DOMContentLoaded', () => {
    console.log('Initializing search bundle manager with metafield approach...');
    
    // Add debug info to window for easy access
    if (typeof window !== 'undefined') {
        // console.log('Debug function available: Call window.debugSearchBundleData() to inspect search bundle data');
    }
    
    const searchContainer = document.querySelector('.cc-main-search');
    if (searchContainer) {
        window.searchBundleManager.initializeSearchResults(searchContainer, 'search');
    }
});